export const TEST_ID = 'modal';

export const MODAL_PANEL_TEST_ID = 'modalPanel';
